<template>
    <VModalWrapper :name="name" :title="title" :show-x="!isLoading" :click-to-close="!isLoading" height="auto">
        <div class="export-progress">
            <template v-if="isLoading">
                <div class="export-progress__spinner">
                    <VSpinner></VSpinner>
                </div>
                <p class="export-progress__text">Формируется файл, пожалуйста подождите…</p>
            </template>

            <template v-else-if="isSuccess">
                <div class="export-progress__icon export-progress__icon_success">✓</div>
                <p class="export-progress__text">Файл сформирован, загрузка началась.</p>
                <VButton class="button_green export-progress__button" @click="close">Закрыть</VButton>
            </template>

            <template v-else>
                <div class="export-progress__icon export-progress__icon_error">!</div>
                <p class="export-progress__text export-progress__text_error">{{ errorMessage }}</p>
                <VButton class="button_orange export-progress__button" @click="close">Закрыть</VButton>
            </template>
        </div>
    </VModalWrapper>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';

import VButton from '../components/VButton/VButton.vue';
import VModalWrapper from '../components/VModalWrapper/VModalWrapper.vue';
import VSpinner from '../components/VProgress/VSpinner.vue';
import ModalNames from '../../js/enums/ModalNames';

const STATUS = {
    LOADING: 'loading',
    SUCCESS: 'success',
    ERROR: 'error',
};

const DEFAULT_ERROR = 'Не удалось сформировать файл. Попробуйте позже.';

@Component({
    components: {
        VButton,
        VModalWrapper,
        VSpinner,
    },
})
class VExportProgressModal extends Vue {
    name = ModalNames.EXPORT_PROGRESS;
    status = STATUS.LOADING;
    errorMessage = '';

    get isLoading() {
        return this.status === STATUS.LOADING;
    }

    get isSuccess() {
        return this.status === STATUS.SUCCESS;
    }

    get title() {
        if (this.isLoading) return 'Формирование файла';
        if (this.isSuccess) return 'Готово';
        return 'Ошибка';
    }

    onStart() {
        this.status = STATUS.LOADING;
        this.errorMessage = '';
        this.$modal.show(this.name);
    }

    onSuccess() {
        this.status = STATUS.SUCCESS;
    }

    onError(message) {
        this.status = STATUS.ERROR;
        this.errorMessage = message || DEFAULT_ERROR;
    }

    close() {
        this.$modal.hide(this.name, { force: true });
    }

    created() {
        this.$bus.on('export:progress:start', this.onStart);
        this.$bus.on('export:progress:success', this.onSuccess);
        this.$bus.on('export:progress:error', this.onError);
    }

    beforeDestroy() {
        this.$bus.off('export:progress:start', this.onStart);
        this.$bus.off('export:progress:success', this.onSuccess);
        this.$bus.off('export:progress:error', this.onError);
    }
}

export default VExportProgressModal;
</script>
<style lang="scss">
.export-progress {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    &__spinner {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 60px;
        margin-bottom: 8px;
    }

    &__text {
        margin: 0 0 24px 0;
        font-size: 1.1rem;
        line-height: 1.5;

        &_error {
            color: #c62828;
            word-break: break-word;
        }
    }

    &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 56px;
        margin-bottom: 16px;
        border-radius: 50%;
        font-size: 30px;
        font-weight: 700;
        color: #fff;

        &_success {
            background-color: #2e7d32;
        }

        &_error {
            background-color: #c62828;
        }
    }

    &__button {
        min-width: 140px;
    }
}
</style>
